<template>
    <div>
    <oma-player :handsetdate="true"></oma-player>
    </div>
</template>

<script>
import OmaPlayer from './components/OmaPlayer.vue'

export default {
  data: () => { return {
  }},
  created: function () {

  },
  methods: {
  },
  components: {
    OmaPlayer,
  }
}
</script>

<style scoped>
div {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
}
</style>
